import React from 'react';
import { Link } from 'react-router-dom';

const BackIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
  </svg>
);

const PageHeader = ({ title, emoji, subtitle, backTo, onBack, backLabel, actions }) => {
  const backClassName = 'btn-clay-ghost mr-4 p-2 flex-shrink-0';
  const label = backLabel ?? 'Back';

  // Reason: backTo wins when both are passed, so the bar never renders two back controls.
  let back = null;
  if (backTo) {
    back = (
      <Link to={backTo} className={backClassName} aria-label={label}>
        <BackIcon />
      </Link>
    );
  } else if (onBack) {
    back = (
      <button type="button" onClick={onBack} className={backClassName} aria-label={label}>
        <BackIcon />
      </button>
    );
  }

  return (
    <div className="bg-surface border-b-3 border-clay-border shadow-clay-sm">
      <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-wrap items-center justify-between gap-y-3">
          <div className="flex items-center min-w-0">
            {back}
            <div className="min-w-0">
              {title != null && title !== false && (
                <h1 className="font-display text-2xl font-bold text-heading flex items-center gap-2">
                  {emoji && <span role="img" aria-hidden="true">{emoji}</span>}
                  {title}
                </h1>
              )}
              {subtitle != null && subtitle !== false && <p className="text-sm text-secondary-text mt-1">{subtitle}</p>}
            </div>
          </div>
          {actions && (
            <div className="flex flex-wrap items-center justify-end gap-2 ml-auto">{actions}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
